export const HomeData1 = [
    {
        linkHome:"https://www.linkedin.com/in/ahmed-azzoz-aa1873246/",
        iconHome:"ri-linkedin-box-line"
    },
    {
        linkHome:"https://github.com/Ahmed-Azoz1",
        iconHome:"ri-github-line"
    },
    {
        linkHome:"https://www.facebook.com/profile.php?id=100083517627587",
        iconHome:"ri-dribbble-line"
    },
]



export const HomeData2 = [
    {
        infoTitle:`BIOGRAPHY`,
        infoDescription1:`Hi, I'm Ahmed, FullStack Developer.`,
        infoDescription2:'Passionate about designing beautiful web',
        infoDescription3:'interfaces. Based in Egypt.',
    },
    {
        infoTitle:`CONTACT`,
        infoDescription1:`Fayoum, Egypt`,
        infoDescription2:'ahmedazouz022@gmail.com',
        infoDescription3:'+20103505324',
    },
    {
        infoTitle:`SERVICES`,
        infoDescription1:`Website Programing`,
        infoDescription2:'FrontEnd Developer',
        infoDescription3:'BackEnd Developer',
    },
]

export const HomeData3 = [
    {
        infoTitle:'YEARS OF EXPERIENCE',
        infoNumber:'03+',
    },
    {
        infoTitle:'COMPLETED PROJECTS',
        infoNumber:'09+',
    },
    {
        infoTitle:'COMPANIES WORKED',
        infoNumber:'07+',
    },
]